var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512px",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    width: "512px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_x36_01_x2C__Night_x2C__moon_x2C__romance_x2C__romantic_x2C__park"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M285.21,94.42c7.51,0,13.6,6.08,13.6,13.59c0,7.51-6.09,13.59-13.6,13.59    c-7.5,0-13.59-6.08-13.59-13.59C271.62,100.5,277.71,94.42,285.21,94.42z",
    style: {
      fill: "#AED3E5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.46,103.99c4.128,0,7.818,1.844,10.313,4.745c0.014-0.242,0.037-0.48,0.037-0.726    c0-7.51-6.09-13.59-13.6-13.59c-7.5,0-13.59,6.08-13.59,13.59c0,3.383,1.243,6.468,3.286,8.846    C275.285,109.686,281.204,103.99,288.46,103.99z",
    style: {
      fill: "#95C0D1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.13,85.36c10.011,0,18.12,8.11,18.12,18.12c0,10.01-8.109,18.12-18.12,18.12    c-10.01,0-18.12-8.11-18.12-18.12C181.01,93.47,189.12,85.36,199.13,85.36z",
    style: {
      fill: "#AED3E5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.006,114.48c0-10.01,8.11-18.12,18.12-18.12c5.129,0,9.75,2.138,13.046,5.561    c-0.792-9.278-8.558-16.561-18.042-16.561c-10.01,0-18.12,8.11-18.12,18.12c0,4.881,1.938,9.301,5.075,12.559    C186.041,115.524,186.006,115.006,186.006,114.48z",
    style: {
      fill: "#95C0D1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.84,153.63c11.54,11.53,6.771,29.44,6.99,52.29c-22.859-0.21-40.75,4.54-52.29-7    c-6.37-6.37-6.46-16.61-0.21-22.86c5.66-5.66,11.37-5.6,19.97-2.66c-2.939-8.6-2.989-14.32,2.671-19.98    C247.23,147.16,257.47,147.26,263.84,153.63z",
    style: {
      fill: "#EF3E5C"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M263.84,153.63c-6.37-6.37-16.609-6.47-22.869-0.21c-2.785,2.785-4.183,5.586-4.538,8.737       c6.136-3.433,14.107-2.489,19.407,2.811c9.573,9.565,7.924,23.524,7.208,41.048c2.526-0.076,5.119-0.121,7.782-0.096       C270.61,183.07,275.38,165.16,263.84,153.63z",
    style: {
      fill: "#E42A53"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M108.521,275.641c-40.03,0.01-72.49-32.451-72.49-72.491c0-27.29,15.1-51.06,37.39-63.42    c-0.92-3.59-1.31-7.39-1.08-11.31c1.091-18.01,15.61-32.67,33.601-33.91c21.189-1.47,38.83,15.28,38.83,36.15    c0,3.13-0.4,6.17-1.15,9.07c22.04,12.22,37.04,35.58,37.38,62.48c0.51,39.49-31.24,72.479-70.729,73.409    C109.681,275.629,109.101,275.641,108.521,275.641z",
    style: {
      fill: "#8EAA39"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.154,209.609c0-27.29,15.1-51.06,37.39-63.42c-0.92-3.59-1.31-7.39-1.08-11.31    c1.091-18.01,15.61-32.67,33.601-33.91c4.059-0.282,7.985,0.11,11.685,1.067c-6.764-5.258-15.438-8.176-24.809-7.526    c-17.99,1.24-32.51,15.9-33.601,33.91c-0.229,3.92,0.16,7.72,1.08,11.31c-22.29,12.36-37.39,36.13-37.39,63.42    c0,31.175,19.681,57.749,47.287,67.985C62.81,258.332,49.154,235.57,49.154,209.609z",
    style: {
      fill: "#809630"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.3,59.19c34.29,5.75,60.42,35.55,60.42,71.47c0,40.04-32.45,72.49-72.489,72.49    c-23.351,0-44.11-11.05-57.36-28.2c3.92,0.66,7.95,1.02,12.06,1.02c40.03,0,72.49-32.45,72.49-72.49    C389.42,86.8,383.77,71.44,374.3,59.19z",
    style: {
      fill: "#FFD15C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.204,182.587c3.92,0.66,7.95,1.02,12.06,1.02c40.03,0,72.49-32.45,72.49-72.49    c0-16.68-5.65-32.04-15.12-44.29c8.064,1.353,15.669,4.049,22.597,7.829c-9.568-7.863-21.184-13.329-33.931-15.467    c9.47,12.25,15.12,27.61,15.12,44.29c0,40.04-32.46,72.49-72.49,72.49c-4.109,0-8.14-0.36-12.06-1.02    c6.142,7.95,13.9,14.586,22.779,19.421C323.406,190.888,319.563,186.935,316.204,182.587z",
    style: {
      fill: "#E8B74B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 45.311,
    style: {
      fill: "#743629"
    },
    width: 27.18,
    x: 407.54,
    y: 402.5
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "414.707,410.166 434.72,410.166 434.72,402.5 407.54,402.5 407.54,447.811     414.707,447.811   ",
    style: {
      fill: "#632D24"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 45.311,
    style: {
      fill: "#743629"
    },
    width: 27.19,
    x: 199.13,
    y: 402.5
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.797,411.334 226.32,411.334 226.32,402.5 199.13,402.5 199.13,447.811     206.797,447.811   ",
    style: {
      fill: "#632D24"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "470.97,366.26 470.97,402.5 434.72,402.5 407.54,402.5 226.32,402.5 199.13,402.5     181.01,402.5 181.01,366.26 226.32,366.26 425.66,366.26   ",
    style: {
      fill: "#924B35"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.676,375.928 234.986,375.928 434.326,375.928 470.97,375.928 470.97,366.26     425.66,366.26 226.32,366.26 181.01,366.26 181.01,402.5 189.676,402.5   ",
    style: {
      fill: "#743629"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.91,298.77H190.07c-2.762,0-5-2.238-5-5s2.238-5,5-5h271.84c2.762,0,5,2.238,5,5    S464.672,298.77,461.91,298.77z",
    style: {
      fill: "#743629"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.85,262.52H199.13c-2.761,0-5-2.238-5-5c0-2.761,2.239-5,5-5h253.72c2.762,0,5,2.239,5,5    C457.85,260.281,455.611,262.52,452.85,262.52z",
    style: {
      fill: "#743629"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.91,335.01H190.07c-2.762,0-5-2.238-5-5s2.238-5,5-5h271.84c2.762,0,5,2.238,5,5    S464.672,335.01,461.91,335.01z",
    style: {
      fill: "#743629"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.66,371.26c-2.762,0-5-2.238-5-5V239.4c0-2.761,2.238-5,5-5s5,2.239,5,5v126.86    C430.66,369.021,428.422,371.26,425.66,371.26z",
    style: {
      fill: "#743629"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.32,371.26c-2.762,0-5-2.238-5-5V239.4c0-2.761,2.238-5,5-5c2.761,0,5,2.239,5,5v126.86    C231.32,369.021,229.081,371.26,226.32,371.26z",
    style: {
      fill: "#743629"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.521,235.34c-1.28,0-2.56-0.488-3.536-1.464c-1.952-1.953-1.952-5.119,0-7.071l36.25-36.25    c1.953-1.952,5.118-1.952,7.071,0c1.953,1.953,1.953,5.119,0,7.071l-36.25,36.25C111.079,234.852,109.8,235.34,108.521,235.34z",
    style: {
      fill: "#743629"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.516,217.22c-0.953,0-1.917-0.272-2.77-0.841l-27.181-18.13    c-2.297-1.532-2.917-4.637-1.385-6.934c1.532-2.298,4.637-2.918,6.934-1.385l27.181,18.13c2.297,1.532,2.917,4.637,1.385,6.934    C111.717,216.439,110.131,217.22,108.516,217.22z",
    style: {
      fill: "#743629"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.521,452.811c-2.762,0-5-2.238-5-5V175.97c0-2.761,2.238-5,5-5c2.761,0,5,2.239,5,5v271.841    C113.521,450.572,111.281,452.811,108.521,452.811z",
    style: {
      fill: "#924B35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.97,452.811H45.09c-2.761,0-5-2.238-5-5s2.239-5,5-5h425.88c2.762,0,5,2.238,5,5    S473.731,452.811,470.97,452.811z",
    style: {
      fill: "#415A6B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.28,452.811c-2.762,0-5-2.238-5-5v-90.621c0-2.762,2.238-5,5-5c2.761,0,5,2.238,5,5v90.621    C77.28,450.572,75.041,452.811,72.28,452.811z",
    style: {
      fill: "#415A6B"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPark);
export default __webpack_public_path__ + "static/media/park.c5ac2e0a9599f8850a9741e752c876de.svg";
export { ForwardRef as ReactComponent };